<template>
    <div class="container">
        <div class="my-main" v-loading="isLoading" element-loading-text="查询中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.6)">
            <div class="title">
                <h3>美国整柜直送 - 在线报价</h3>
            </div>
            <div class="nav">
                <el-radio-group @input="changeType" class="first" v-model="queryData.storeType">
                    <el-radio label="1">{{ $t('truck.thirdPart') }}</el-radio>
                    <el-radio label="2">{{ $t('truck.amazon') }}</el-radio>
                    <el-radio label="3">
                        <div class="nav_button">
                            <img src="@/assets/icon/tax.svg" v-show="queryData.storeType !== '3'" alt="">
                            <img src="@/assets/icon/tax2.svg" v-show="queryData.storeType == '3'" alt="">
                            <div class="text">
                                <p>2023年</p>
                                <p>美国税率</p>
                            </div>
                        </div>
                    </el-radio>
                </el-radio-group>
            </div>
            <div v-if="queryData.storeType == '1' || queryData.storeType == '2'">
                <div class="form">
                    <el-form>
                        <!-- <el-row>
                        <el-col :span="24">
                            <el-form-item>
                               
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                        <el-row>
                            <el-col :span="24">
                                <el-form-item class="text">
                                    <template slot="label">
                                        <div class="label">
                                            <el-tooltip v-if="queryData.storeType == '1'" content="试试输入 '4PX，谷仓，万邑通'"
                                                popper-class="map_tip" effect="dark" placement="top">
                                                <div>
                                                    <span>{{ $t('truck.cityOrZip') }}</span>
                                                    <span>(Delivery To)</span>
                                                </div>
                                            </el-tooltip>
                                            <div v-else class="el-tooltip">
                                                <span>{{ $t('truck.FBACode') }}</span>
                                                <span>(Delivery To)</span>
                                            </div>

                                        </div>
                                    </template>
                                    <el-autocomplete clearable @keyup.delete.native="formatWarehouseAddr" value-key="label"
                                        v-show="queryData.storeType == '1'" style="width: 100%;" class="inline-input"
                                        v-model="queryData.warehouseAddr" :fetch-suggestions="querySearch"
                                        :placeholder=" $t('truck.pls.city')" @select="handleSelect"
                                        @clear="clearSelect"></el-autocomplete>
                                    <el-autocomplete clearable @keyup.native="formatFbaCode" value-key="fbaCode"
                                        v-show="queryData.storeType == '2'" style="width: 100%;" v-model="queryData.fbaCode"
                                        @select="handleSelectForFba" :fetch-suggestions="querySearchForFba"
                                        @clear="clearSelectForFba" :placeholder=" $t('truck.pls.FBACode')" >
                                    </el-autocomplete>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item class="text">
                                    <template slot="label">
                                        <div class="label">
                                            <span>{{ $t('truck.PortOfDischarge') }}</span>
                                            <span>(Delivery From)</span>
                                        </div>
                                    </template>
                                    <el-select style="width: 100%;" :disabled="queryData.storeType == '2'"
                                        @change="deliveryFromSelected" v-model="queryData.deliveryFrom"
                                        :placeholder=" $t('truck.pls.PortOfDischarge')" >
                                        <el-option v-for="item in pop" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                    <!-- <div v-if="deliveryFrom.distance && queryData.storeType == '1'" class="distance">
                                    直线距离：{{ deliveryFrom.distance.toFixed(2) }} km
                                </div> -->
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24" v-show="queryData.storeType == '1'">
                                <el-button :disabled="popNumber <= 0" @click="getTruckQuotation" class="search">
                                    <div class="search_btn">
                                        <span class="name">{{ $t('truck.getPrice') }}</span>
                                        <span class="type">
                                            <span>{{ $t('truck.type2') }}</span>
                                            <span>40'/45'</span>
                                        </span>
                                    </div>
                                </el-button>

                            </el-col>
                            <el-col :span="24" v-show="queryData.storeType == '2'">
                                <el-button @click="getTruckQuotationByFba" class="search">
                                    <div class="search_btn">
                                        <span class="name">{{ $t('truck.getPrice') }}</span>
                                        <span class="type">
                                            <span>{{ $t('truck.type2') }}</span>
                                            <span>40'/45'</span>
                                        </span>
                                    </div>
                                </el-button>
                            </el-col>
                            <div class="lang phone" v-show="$route.name == 'home'">
                                <!-- <span>语言：</span> -->
                                <!-- <el-select @change="changeLang" v-model="lang" placeholder="">
                                    <el-option label="中文" value="zh_CN">
                                    </el-option>
                                    <el-option label="English" value="en_US">
                                    </el-option>
                                </el-select> -->
                                <el-button @click="changeLang">
                                    <span>{{ $i18n.locale == 'zh_CN' ? '中文' : 'English' }}</span>
                                    <img src="@/assets/icon/trans.svg" style="width: 11px;margin-left: 5px;" />
                                </el-button>

                            </div>
                            <div v-if="deliveryFrom.distance && queryData.storeType == '1'" class="distance">
                                {{ $t('truck.distance') }}：{{ deliveryFrom.distance.toFixed(2) }} km
                            </div>
                        </el-row>
                    </el-form>
                </div>
                <div class="table">
                    <el-table stripe :data="tableData">
                        <el-table-column :label="$t('truck.table.name')" width="110">
                            <template slot-scope="scope">
                                <span>   {{ trans(scope.row.desc) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column width="70" :label="$t('truck.table.amount')">
                            <template slot-scope="scope">
                                <span> {{ parseFloat(scope.row.amount.toFixed(2)).toLocaleString() }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column :label="$t('truck.table.remark')" width="auto">
                            <template slot-scope="scope">
                                <span style="font-size: 12px">  {{ trans(scope.row.remark) }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- -->
                    <!-- <div class="total" v-show="total > 0">
                        <div class="amount">
                            <span v-show="deliveryFrom.distance <= 600">合计 :</span>
                            <span v-show="deliveryFrom.distance <= 600"> {{ total > 0 ? '$' +
                                parseFloat(total.toFixed(2)).toLocaleString() : '请单询' }}</span>
                            <span v-show="deliveryFrom.distance > 600">派送距离较长，请单询。</span>
                        </div>
                        <div class="date" v-show="deliveryFrom.distance <= 600">
                            <span>有效期 :</span>
                            <span>{{ this.addThreeDays() }}</span>
                        </div>
                    </div> -->
                    <div class="total"  v-if="queryData.storeType == '1'&&total != 0"  >
                    <div class="amount">
                        <span v-show="deliveryFrom.distance <= 600">{{ $t('truck.total') }} :</span>
                        <span v-show="deliveryFrom.distance <= 600"> {{ total > 0 ? '$' +
                            parseFloat(total.toFixed(2)).toLocaleString() : $t('truck.dan') }}</span>
                        <span v-show="deliveryFrom.distance > 600">{{ $t('truck.dan2') }}</span>
                    </div>
                    <div class="date" v-show="deliveryFrom.distance <= 600">
                        <span>{{ $t('truck.endTime') }} :</span>
                        <span>{{ this.addThreeDays() }}</span>
                    </div>
                </div>
                <div class="total"  v-if="queryData.storeType == '2'&&total != 0"  >
                    <div class="amount">
                        <span >{{ $t('truck.total') }} :</span>
                        <span > {{ total > 0 ? '$' +
                            parseFloat(total.toFixed(2)).toLocaleString() :  $t('truck.dan') }}</span>
                   
                    </div>
                    <div class="date">
                        <span>{{ $t('truck.endTime') }} :</span>
                        <span>{{ this.addThreeDays() }}</span>
                    </div>
                </div>
                </div>
                <div class="end">
                    <el-row>
                        <el-col :span="24">
                            <div class="a_map">
                                <!-- <div class="info">
                                    <p>{{ $t('truck.more') }}
                                        <a href="https://pricing.mintfirst.com">Pricing.mintfirst.com</a>
                                    </p>
                                </div> -->
                                <mapComponent @getDistance="getDistance" ref="myMap" :coordinate="coordinate"
                                    :height="130" />
                                    <div class="desc" v-show="distance > 0">
                                <div class="to">
                                    <span><b>{{ $t('truck.from') }}: </b> </span>
                                    <span>{{ queryData.storeType == '1' ? deliveryFrom.city : deliveryFromInfo.podName
                                    }}</span>
                                </div>
                                <div class="to">
                                    <span><b>{{ $t('truck.to') }}: </b> </span>
                                    <span>{{ deliveryToInfo }}</span>
                                </div>
                                <div class="from" v-show="distance > 0">
                                    <span><b>{{ $t('truck.mileage') }}: </b> </span>
                                    <span>{{ distance.toFixed(2) }} km</span>
                                </div>
                            </div>
                            </div>
                        </el-col>
                    </el-row>

                </div>

            </div>
            <div v-else class="tax">
                <taxVue @checkIsLogin="checkIsLogin" />
            </div>
            <div class="contact">
                <div class="text">
                    <div class="block">
                        <p> <span>{{ $t('truck.phone') }}：</span> <a href="tel:18930215002">189 3021 5002</a></p>
                        <p> <span>E-mail：</span> <a href="mailto:troy@mintfirst.com">troy@mintfirst.com</a></p>

                    </div>
                    <!-- <div class="block">
                       <p> <span>联系电话：</span><a href="tel:18621567453"> 186 2156 7453</a></p>
                       <p> <span>E-mail：</span><a href="mailto:leo@mintfirst.com">leo@mintfirst.com</a></p>
                       
                    </div> -->
                </div>
                <div class="message">
                    <input v-model="contactMessage" :placeholder="$t('truck.pls.phone')" type="text">
                    <button @click="recordContact">{{ $t('truck.btn.send') }}</button>
                </div>
            </div>
            <!-- <div class="footer">
                <p>
                    <span>
                        Copyright © 2016-2023 | 明特（上海）国际物流有限公司
                    </span>
                    <span>All Rights Reserve |<a href="https://beian.miit.gov.cn/"> 沪ICP备14028382号</a></span>
                </p>
            </div>  -->
        </div>
        <Register ref="myRegister" />
        <div class="isfirst" v-show="isFirstVisit">
            <div class="form">
                <h3>输入美国邮编，一键查询卡车运价!</h3>
                <el-form>
                    <el-row :gutter="10">
                        <el-col :span="24" id="code">
                            <el-form-item>
                                <template slot="label">
                                    <div class="label">
                                    </div>
                                </template>
                                <el-autocomplete clearable @keyup.delete.native="formatWarehouseAddr" value-key="label"
                                    style="width: 100%;" class="inline-input first_input" :autofocus="true"
                                    v-model="queryData.warehouseAddr" :fetch-suggestions="querySearch" placeholder="输入邮编"
                                    @select="handleSelect" @clear="clearSelect"></el-autocomplete>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" id="button">
                            <el-form-item>
                                <template slot="label">
                                    <div class="label">
                                    </div>
                                </template>
                                <el-button :disabled="popNumber <= 0" id="query1" @click="getTruckQuotation"
                                    class="search">获取卡车报价！</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>
  
<script>
import Register from '@/views/register/phone/index.vue';
import mapComponent from '@/components/mapComponent.vue'
import { log } from 'mathjs'
import taxVue from './components/tax.vue'
export default {
    name: 'container',
    components: {
        mapComponent,
        taxVue,
        Register
    },
    data: function () {
        return {
            lang: 'zh_CN',
            isFirstVisit: true,
            nowTime: "",
            expireTime: "",
            aData: [{
                desc: "清关费",
                amount: 0,
                remark: "每票",
                index: 1
            },
            {
                desc: "换单费",
                amount: 15,
                remark: "每票",
                index: 1
            },
            {
                desc: "ISF",
                amount: 0,
                remark: "每票",
                index: 2
            },
            {
                desc: "码头附加费",
                amount: 0,
                remark: "40HQ",
                index: 3
            },
            {
                desc: "车架费",
                amount: 0,
                remark: "$50/天，最少三天",
                index: 4
            },
            {
                desc: "送货费",
                amount: 0,
                remark: "含燃油附加费",
                index: 5
            },
                // {
                //     desc: "预提费",
                //     amount: 0,
                //     remark: "原因：LFD/仓库收货/码头关闭",
                //     index: 6
                // },
                // {
                //     desc: "卡车堆场仓储费",
                //     amount: 0,
                //     remark: "每天",
                //     index: 7
                // }, {
                //     desc: "Drop off",
                //     amount: 0,
                //     remark: "车队/仓库要求",
                //     index: 8
                // }
            ],
            aData2: [{
                desc: "清关费",
                amount: 85,
                remark: "每票",
                index: 1
            },
            {
                desc: "换单费",
                amount: 15,
                remark: "每票",
                index: 1
            },
            {
                desc: "ISF",
                amount: 6,
                remark: "每票",
                index: 2
            },
            // {
            //     desc: "码头附加费",
            //     amount: 0,
            //     remark: "",
            //     index: 3
            // },
            {
                desc: "车架费",
                amount: 0,
                remark: "$50/天，最少三天",
                index: 4
            },
            {
                desc: "直送全包费用",
                amount: 0,
                remark: "",
                index: 5
            }
            ],
            tableData: [{
                desc: "清关费",
                amount: 0,
                remark: "每票",
                index: 1
            },
            {
                desc: "换单费",
                amount: 0,
                remark: "每票",
                index: 1
            },
            {
                desc: "ISF",
                amount: 0,
                remark: "每票",
                index: 2
            },
            {
                desc: "码头附加费",
                amount: 0,
                remark: "40HQ",
                index: 3
            },
            {
                desc: "车架费",
                amount: 0,
                remark: "$50/天，最少三天",
                index: 4
            },
            {
                desc: "送货费",
                amount: 0,
                remark: "含燃油附加费",
                index: 5
            },
                // {
                //     desc: "预提费",
                //     amount: 0,
                //     remark: "原因：LFD/仓库收货/码头关闭",
                //     index: 6
                // },
                // {
                //     desc: "卡车堆场仓储费",
                //     amount: 0,
                //     remark: "每天",
                //     index: 7
                // }, {
                //     desc: "Drop off",
                //     amount: 0,
                //     remark: "车队/仓库要求",
                //     index: 8
                // }
            ],
            isLoading: false,
            options: [],
            queryData: {
                warehouseAddr: "",
                deliveryFrom: "",
                container: "1",
                storeType: "1",
                fbaCode: "ONT8"
            },
            coordinate: {
                start: [-117.59998, 34.13762],
                end: [-118.262848, 33.743559]
            },
            total: 0,
            pop: [],
            popNumber: 0,
            cityId: 0,
            deliveryFromInfo: "",
            deliveryToInfo: "",
            deliveryFrom: "",
            MyMap: "",
            distance: 0,
            empty: [],
            contactMessage: "",
        }
    },
    created() {

    },
    methods: {
        trans(key) {
            // return key
            // console.log('obj', key);
            switch (key) {
                case '清关费':
                    return this.$t('truck.table.clearance')
                case '换单费':
                    return this.$t('truck.table.carrier')
                case 'ISF':
                    return 'ISF'
                case '码头附加费':
                    return this.$t('truck.table.terminal')
                case '车架费':
                    return this.$t('truck.table.chassis')
                case '送货费':
                    return this.$t('truck.table.delivery')
                case '预提费':
                    return this.$t('truck.table.prePull')
                case '卡车堆场仓储费':
                    return this.$t('truck.table.storag')
                case '直送全包费用':
                    return this.$t('truck.table.deliveryAll')
                case 'Drop off':
                    return 'Drop off Fee'
                case '每票':
                    return this.$t('truck.table.bill')
                case '$50/天，最少三天':
                    return this.$t('truck.table.e1')
                case '含燃油附加费':
                    return this.$t('truck.table.e2')
                case '原因：LFD/仓库收货/码头关闭':
                    return this.$t('truck.table.e3')
                case '每天':
                    return this.$t('truck.table.e4')
                case '车队/仓库要求':
                    return this.$t('truck.table.e5')
                case 'Drop off':
                    return 'Drop off Fee'

                default:
                    return key;
            }
        },
        changeLang() {
            let value = this.$i18n.locale == 'zh_CN' ? 'en_US' : 'zh_CN';
            this.$i18n.locale = value
            localStorage.setItem('language', value)
        },
        isFirstVisitFun() {
            // if (localStorage.getItem('isFirstVisit'))
            //     this.isFirstVisit = false
            // else {
            //     localStorage.setItem('isFirstVisit', 'isFirst')
            //     this.isFirstVisit = true
            // }
            if (!localStorage.getItem('isFirstVisit'))
                this.isFirstVisit = true
            else this.isFirstVisit = false
        },
        checkIsLogin() {
            if (this.getCookie()) return true
            else {
                this.$refs.myRegister.showRegister()
                return false
            }
        },
        getCookie() {
            return this.$Cookie.get('user_email')
        },
        fbaSearchRecord() {
            this.$http.get(`kp/record?fbaCode=${this.queryData.fbaCode}`)
                .then((res) => {


                }).catch((err) => {


                })
        },
        // 格式化仓库代码
        formatFbaCode() {
            this.queryData.fbaCode = this.queryData.fbaCode.toUpperCase().slice(0, 4)
            if (this.queryData.fbaCode.length < 4) {
                this.deliveryFromInfo = ""
                this.queryData.deliveryFrom = ""
            }
        },
        formatWarehouseAddr() {
            this.pop = []
            this.queryData.deliveryFrom = ""
            this.distance = 0
            this.popNumber = 0
        },
        // 初始化表格数据
        setTableData(type) {
            type == 1 ? this.tableData = [{
                desc: "清关费",
                amount: 0,
                remark: "每票",
                index: 1
            },
            {
                desc: "换单费",
                amount: 0,
                remark: "每票",
                index: 1
            },
            {
                desc: "ISF",
                amount: 0,
                remark: "每票",
                index: 2
            },
            {
                desc: "码头附加费",
                amount: 0,
                remark: "40HQ",
                index: 3
            },
            {
                desc: "车架费",
                amount: 0,
                remark: "$50/天，最少三天",
                index: 4
            },
            {
                desc: "送货费",
                amount: 0,
                remark: "含燃油附加费",
                index: 5
            },
                // {
                //     desc: "预提费",
                //     amount: 0,
                //     remark: "原因：LFD/仓库收货/码头关闭",
                //     index: 6
                // },
                // {
                //     desc: "卡车堆场仓储费",
                //     amount: 0,
                //     remark: "每天",
                //     index: 7
                // }, {
                //     desc: "Drop off",
                //     amount: 0,
                //     remark: "车队/仓库要求",
                //     index: 8
                // }
            ] : this.tableData = [{
                desc: "清关费",
                amount: 0,
                remark: "每票",
                index: 1
            },
            {
                desc: "换单费",
                amount: 0,
                remark: "每票",
                index: 1
            },
            {
                desc: "ISF",
                amount: 0,
                remark: "每票",
                index: 2
            },
            {
                desc: "码头附加费",
                amount: 0,
                remark: "40HQ",
                index: 3
            },
            {
                desc: "车架费",
                amount: 0,
                remark: "$50/天，最少三天",
                index: 4
            },
            {
                desc: "直送全包费用",
                amount: 0,
                remark: "",
                index: 5
            }
            ]
        },
        setTableDataS() {
            this.tableData = [{
                desc: "清关费",
                amount: 0,
                remark: "每票",
                index: 1
            },
            {
                desc: "换单费",
                amount: 0,
                remark: "每票",
                index: 2
            },
            {
                desc: "ISF",
                amount: 0,
                remark: "每票",
                index: 3
            },
            {
                desc: "码头附加费",
                amount: 0,
                remark: "40HQ",
                index: 4
            },
            {
                desc: "车架费",
                amount: 0,
                remark: "$50/天，最少三天",
                index: 5
            },
            {
                desc: "送货费",
                amount: 0,
                remark: "",
                index: 6
            },
            {
                desc: "含燃油附加费",
                amount: 0,
                remark: "",
                index: 7
            }
            ]
        },
        // 清空搜索数据
        clearTableData(type) {
            this.deliveryFromInfo = ""
            this.deliveryFrom = ""
            this.distance = 0
            this.total = 0
            this.popNumber = 0
            this.setTableData(type)
            this.$refs.myMap.clearLine()
        },
        nullSearch() {

            this.total = 0
            this.setTableData(type)
            this.$refs.myMap.clearLine()
        },
        async changeType(val) {
            if (this.$refs.myMap)
                this.$refs.myMap.clearLine()

            this.total = 0
            this.distance = 0
            if (val == '1') {
                this.pop = []
                this.popNumber = 0
                this.deliveryFromInfo = ""
                this.queryData.deliveryFrom = ""
                this.queryData.warehouseAddr = ""
                this.setTableData(1)
            } else {
                // if (this.isFirst) {
                // this.isFirst = false
                await this.searchDataForFba(this.queryData.fbaCode).then((res) => {
                    if (res.length == 1) {
                        this.setDataForFba(res[0])
                        // this.setTableData(2)
                        this.queryData.deliveryFrom = res[0].podName
                        this.deliveryFrom = res[0]
                        this.deliveryFromInfo = res[0]
                        this.deliveryToInfo = res[0].fbaAddress
                    }

                    // this.aData2.map((e) => {
                    //     this.total += e.amount
                    // })
                    // this.getLine()

                })
                // }
                this.setTableData(2)


            }

        },
        getDistance(val) {
            this.distance = val
        },
        addThreeDays() {
            let date = new Date()
            if (!date) {
                return null;
            }
            date.setMonth(date.getMonth() + 1)
            date.setDate(15);
            return date.toLocaleDateString();
        },
        clearSelect() {
            this.pop = []
            this.queryData = {
                warehouseAddr: "",
                deliveryFrom: "",
                container: "1",
                storeType: "1",
                fbaCode: "ONT8"
            }
            this.clearTableData(1)
        },
        clearSelectForFba() {

            this.queryData = {
                warehouseAddr: "",
                deliveryFrom: "",
                container: "1",
                storeType: "2",
                fbaCode: ""
            }
            this.clearTableData(2)
        },
        setData(res, type) {
            if (type) {
                this.setTableDataS()
                this.tableData[5].remark = ''
                this.tableData[6].amount = res.fuelSurcharge ? parseFloat(res.fuelSurcharge) : 0
            }
            this.tableData[0].amount = res.clearFee ? parseFloat(res.clearFee) : 0
            this.tableData[1].amount = res.isfFee ? 15 : 0
            this.tableData[2].amount = res.isfFee ? parseFloat(res.isfFee) : 0
            this.tableData[3].amount = res.additionalFee ? parseFloat(res.additionalFee) : 0
            this.tableData[4].amount = res.frameFee ? parseFloat(res.frameFee) : 0
            this.tableData[5].amount = res.baseFee ? parseFloat(res.baseFee) : 0
            this.total = 0

            res.baseFee ? this.tableData.map((e) => {
                this.total += e.amount
            }) : this.total = -1
            this.isLoading = false
        },
        setDataForFba(res) {
            this.total = 0
            this.aData2[3].remark = (res.frameRemark)
            this.aData2[3].amount = parseFloat(res.frameFee)
            this.aData2[4].amount = parseFloat(res.deliveryFee)
            this.aData2[4].remark = (res.deliveryRemark)
            this.isLoading = false
        },
        deliveryFromSelected(val) {
            this.deliveryFrom = this.deliveryFromInfo.filter((e) => {
                return e.id == val
            })[0]
            this.coordinate.end = [this.deliveryFrom.longitude, this.deliveryFrom.latitude]
        },
        getTruckQuotation() {
            if (this.isFirstVisit && !localStorage.getItem('isFirstVisit')) {
                this.isFirstVisit = false
                localStorage.setItem('isFirstVisit', 'isFirst')
            }
            this.setTableData(1)
            this.total = 0
            if (!this.queryData.warehouseAddr) {
                this.$message({
                    message: this.$t('truck.pls.FBACode'),
                    type: 'error',
                    customClass: "phone",
                });
                return
            }
            if (!this.queryData.deliveryFrom) {
                this.$message({
                    message:this.$t('truck.pls.PortOfDischarge'),
                    type: 'error',
                    customClass: "phone",
                });
                return
            }
            // if (this.getCookieCount() >= 3) {
            //     this.$message({
            //         message: "抱歉!，手机端使用次数已超过3次限制，请电脑访问使用!",
            //         type: 'error',
            //         customClass: "phone",
            //     });
            //     return
            // }
            // if (this.checkIsLogin()) {
            this.isLoading = true
            this.$http.get(`kp/queryQuotes?cityId=${this.cityId}&
						podId=${this.queryData.deliveryFrom}`)
                .then((res) => {
                    if (res.data) {
                        let flag = parseFloat(res.data.fuelSurcharge) > 0 ? true : false
                        setTimeout(() => {
                            this.setData(res.data, flag)
                        }, 500)
                        this.$refs.myMap.getAddressMsg(this.coordinate.start, this.coordinate.end)
                        // this.addCookieCount()
                    } else {
                        this.$message({
                            message: this.$t('truck.notic.null2'),
                            type: 'error',
                            offset: '350',
                            customClass: "phone",
                        });
                        this.nullSearch()
                        this.isLoading = false
                    }

                }).catch((err) => {
                    this.isLoading = false

                })
            // }

        },
        async getTruckQuotationByFba() {
            // if (this.checkIsLogin()) {
            this.setTableData(2)
            this.total = 0
            this.isLoading = true
            if (this.deliveryFromInfo.fbaAddress) {
                this.deliveryToInfo = this.deliveryFromInfo.fbaAddress
                await this.getLine()
                this.fbaSearchRecord()
                setTimeout(() => {
                    this.isLoading = false
                    this.tableData = this.aData2
                    this.aData2.map((e) => {
                        this.total += e.amount
                    })
                }, 1000)

            } else this.getInfoByCode()
            // }
        },
        async getInfoByCode() {
            if (this.queryData.fbaCode.length < 4) {
                this.$message({
                    message:  this.$t('truck.pls.FBACode'),
                    type: 'error',
                    customClass: "phone",

                });
                this.isLoading = false
            } else {
                let res = await this.searchDataForFba(this.queryData.fbaCode)
                if (res.length > 0) {
                    this.deliveryFromInfo = res[0]
                    this.queryData.deliveryFrom = res[0].podName
                    await this.getTruckQuotationByFba()
                    this.addCookieCount()
                } else {
                    this.$message({
                        message:  this.$t('truck.notic.null'),
                        type: 'error',
                        offset: '350',
                        customClass: "phone",
                    });
                    this.isLoading = false
                }

            }
        },
        async getLine() {
            this.coordinate.start = await this.transToCoordinate(this.deliveryFromInfo.fbaAddress)
            this.coordinate.end = [this.deliveryFromInfo.longitude, this.deliveryFromInfo.latitude]
            this.$refs.myMap.getAddressMsg(this.coordinate.start, this.coordinate.end)
        },
        handleSelect(val) {
            this.distance = 0
            this.$refs.myMap.clearLine()
            this.clearTableData(1)
            this.cityId = val.value
            this.coordinate.start = val.coordinate
            this.deliveryToInfo = val.label
            this.$http.get(`kp/queryPods?cityId=${val.value}`)
                .then((res) => {
                    this.pop = res.data.map((e) => {
                        return {
                            value: e.id,
                            label: e.city
                        }
                    })
                    this.popNumber = res.data.length
                    this.queryData.deliveryFrom = res.data[0].id
                    this.deliveryFrom = res.data[0]
                    this.coordinate.end = [res.data[0].longitude, res.data[0].latitude]
                    this.deliveryFromInfo = res.data
                }).catch((err) => {

                })
        },
        async handleSelectForFba(val) {
            this.distance = 0
            this.$refs.myMap.clearLine()
            this.clearTableData(2)
            this.setDataForFba(val)
            this.queryData.deliveryFrom = val.podName
            this.deliveryFromInfo = val
        },
        async querySearch(queryString, cb) {
            let results = []
            if (!queryString) results = await this.searchData('')
            else results = await this.searchData(queryString)
            cb(results);
        },
        async querySearchForFba(queryString, cb) {
            let results = []
            if (queryString && queryString.length >= 1) {
                results = await this.searchDataForFba(queryString)
            }
            cb(results);
        },
        async searchData(val) {
            let results = []
            if (val == '' || val.length < 4) {
                return results;
            }
            await this.$http.get(`kp/queryCity?address=${val}`)
                .then((res) => {
                    results = res.data.map((e) => {
                        return {
                            'label': e.cityName + "," + e.stateCode + "," + e.zipCode,
                            'value': e.id,
                            'coordinate': [e.longitude, e.latitude]
                        }
                    })

                }).catch((err) => {

                })
            return results
        },
        async searchDataForFba(val) {
            let results = []
            if (val == '') {
                return result;
            }
            await this.$http.get(`kp/queryFbaQuotes?fbaCode=${val}`)
                .then((res) => {
                    results = res.data

                }).catch((err) => {

                })
            return results
        },
        async transToCoordinate(val) {

            // const query = await fetch(
            //     `https://www.mapquestapi.com/geocoding/v1/address?key=J74m5OPnQihJD43gJy2fOMON3DWixSu7&location=${val}`, {
            //     method: 'GET'
            // }
            // );
            // let res = await query.json();
            // if (res.results[0].locations.length > 0) {
            //     return [res.results[0].locations[0].latLng.lng, res
            //         .results[0].locations[0].latLng.lat]
            // } else {
            //     this.$message({
            //         message: "未查询到该仓库或卸货港信息！",
            //         type: 'error',
            //         customClass: "phone",
            //     });
            // }


            const query = await fetch(
                `https://api.mapbox.com/geocoding/v5/mapbox.places/${val}.json?access_token=pk.eyJ1Ijoib3Jpbm9oYW4iLCJhIjoiY2xlaWJjZHFiMDFmeDQzbWliM3p2NjQ4eSJ9.7iPD5KsH3Ti5Tc2tNmpP3Q`, {
                method: 'GET'
            }
            );


            let res = await query.json();
            if (res.features.length > 0) {
                return res.features[0].center
            } else {
                // ElMessage.error("未查询到该仓库或卸货港信息！")
                this.$message({
                    message: this.$t('truck.notic.null'),
                    type: 'error'
                });

            }
        },
        async getPositionByMapRequest(val) {

            const query = await fetch(
                `https://api.mapbox.com/geocoding/v5/mapbox.places/${val}.json?access_token=pk.eyJ1Ijoib3Jpbm9oYW4iLCJhIjoiY2xlaWJjZHFiMDFmeDQzbWliM3p2NjQ4eSJ9.7iPD5KsH3Ti5Tc2tNmpP3Q`, {
                method: 'GET'
            }
            );


            let res = await query.json();
            if (res.features.length > 0) {
                return res.features[0].center
            } else {
                return []
            }
        },
        getNowTime() {
            var months = ["January", "February", "March", "April", "May", "June", "July", "August",
                "September", "October", "November", "December"
            ]; // 定义月份数组
            var today = new Date(); // 获取当前日期
            var month = months[today.getMonth()]; // 获取当前月份的名称
            var day = today.getDate(); // 获取当前日期
            var year = today.getFullYear(); // 获取当前年份
            return [month + " " + day, year]; // 格式化日期
        },
        recordContact(e) {
            var phone = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
            var email = /^\w+([-\.]\w+)*@\w+([\.-]\w+)*\.\w{2,4}$/;
            e.preventDefault()
            if (this.contactMessage.length > 0) {
                if (phone.test(this.contactMessage) || email.test(this.contactMessage)) {
                    this.$message({
                        message: this.$t('truck.notic.success'),
                        type: 'success',
                        customClass: "phone",
                    });
                    this.record()
                    this.contactMessage = ""
                } else {
                    this.$message({
                        message:  this.$t('truck.notic.error'),
                        type: 'error',
                        customClass: "phone",
                    });

                }
            } else this.$message({
                message: this.$t('truck.notic.contact'),
                type: 'error',
                customClass: "phone",
            });

        },
        record() {
            let obj = {
                "startingPoint": this.deliveryFrom.city,//起始地
                "destination": this.queryData.warehouseAddr, //目的地
                "distance": this.distance, //距离
                "palletsNum": "", //托盘数
                "estimateCost": this.total, //报价
                "remark": this.contactMessage
            }
            this.$http.post(
                'quotation/saveEstimatedRecords', obj
            ).then((res) => { })

        },
        setCookie() {
            if (!this.$Cookie.get('usage_counter_search'))
                this.$Cookie.set('usage_counter_search', 0, 30)
        },
        addCookieCount() {
            this.setCookie()
            let num = parseInt(this.$Cookie.get('usage_counter_search'))
            this.$Cookie.set('usage_counter_search', num + 1)

        },
        getCookieCount() {
            this.setCookie()
            return parseInt(this.$Cookie.get('usage_counter_search'))
        }

    },
    mounted() {
        this.lang = localStorage.getItem('language') || 'zh_CN'
        // this.setCookie()
        this.isFirstVisitFun()
    },
}
</script>
<style scoped>
.lang {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0px;
    top: 23%;
}

.isfirst {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
    /* margin-left: 210px; */
    backdrop-filter: blur(2px);
    overflow: hidden
}

.isfirst .form {
    width: 300px;
    margin: 10px auto;
    /* transform: scale(1.2); */
}

.isfirst .form .label {
    display: none;
}

.isfirst .form .el-form-item ::v-deep .el-form-item__label {
    border-right: none;
}

.isfirst .form h3 {
    text-align: center;
    margin: 15px 0;
    font-size: 18px;
    color: white;
}

.isfirst form {
    background-color: white;
    padding: 10px 20px;
    border-radius: 5px;
}

.isfirst form .el-autocomplete ::v-deep .el-input__inner {
    border: 1px solid #dcdfe6;
    text-align: center;
    margin: 10px 0;
    /* padding: 18px 0; */
}

.title {

    background-color: #035293;
    text-align: center;
    color: white;
    padding: 40px 0 10px 0;

}

.title h3 {
    background: url(@/assets/icon/truck.svg) no-repeat left center;
    background-size: 25px;
    display: inline-block;
    padding-left: 35px;
    font-size: 25px;
}

.nav {
    padding: 10px 15px 0 15px;
}

.info {
    text-align: center;
    padding-bottom: 5px;
    font-size: 12px;
    color: #817f7e;
}

.info a {
    margin-left: 1px;
    color: black;
    font-weight: bold;
}

.el-form-item.text {
    margin-bottom: 0px;
    border: 1px solid #c6c5c5;
    margin: 5px 0;
    border-radius: 5px;
    padding: 0 5px;
    display: flex;
    padding: 3px 0;
}

.el-form-item {
    margin-bottom: 0;
}

.el-form-item ::v-deep .el-form-item__label {

    border-right: 1px solid #c6c5c5;
    text-align: center;

}

.el-form-item.text ::v-deep .el-form-item__label {
    flex: 1 0 36.5%;
    width: 36.5%;
}

.el-form-item.text ::v-deep .el-form-item__content {
    flex: 1 0 63.5%;
    width: 63.5%;
}

.el-form-item .el-input__inner {
    border: none;
    box-shadow: none;
}

.el-form-item ::v-deep .el-input__icon,
.el-form-item ::v-deep .el-form-item__content {
    line-height: 30px;
}

.el-form-item::after,
.el-form-item::before {
    content: '';
    display: unset !important;
}

.el-form-item ::v-deep .form-item__content::before {
    display: none;
}

.container {
    /* width: 1200px; */
    margin: 0 auto;
    box-sizing: border-box;

}


.my-main {
    box-sizing: border-box;

}

.form {
    padding: 10px 15px;
}

.label .el-tooltip,
.label {
    height: 30px;
    line-height: 30px;
    font-weight: bold;
    color: #005bab;
    text-align: center;
    display: flex;
    flex-direction: column;
}

.label span {
    line-height: 15px;
    position: relative;
    top: 3px;
}

.label span:last-of-type {
    font-size: 12px;
    color: #8ec5e2;
    font-weight: normal;
    transform: scale(0.8);

}

.distance {
    /* position: absolute; */
    /* top: 58px; */
    font-size: 12px;
    left: 2px;
    color: #a53400;
    text-align: center;
    /* width: 200px; */
}

.search.el-button.is-disabled,
.search.el-button.is-disabled:focus,
.search.el-button.is-disabled:hover {
    background-color: #f28123;
    color: white;
    opacity: 0.5;
    transform: scale(1.0);
}

.search {
    width: 180px;
    background-color: #f28123;
    height: 40px;
    border: none;
    position: relative;
    transition: 0.2s;
    color: white;
    margin: 5px auto;
    display: block;
    border-radius: 30px;
    font-weight: bold;
    padding: 30px 0;
}

.search.el-button {
    padding: 0;
}

.search .search_btn {
    display: flex;
    align-items: center;
    justify-content: center;

}

.search.el-button .name {
    border-right: 1px solid white;
    padding: 2px 10px 2px 0;
    position: relative;
    left: 9px;
    font-size: 17px;
}

.search.el-button .type {
    line-height: 15px;
    display: flex;
    flex-direction: column;
    transform: scale(0.6);
    position: relative;
    left: 10px;
    top: 1px;
}

.search:hover,
.search.el-button.is-disabled:hover,
.search:active .search.el-button.is-disabled:active,
.search:focus,
.search.el-button.is-disabled:focus {
    background-color: #f28123;
    color: white;
    transform: scale(0.98);
}


.el-select ::v-deep .el-input__inner,
.el-autocomplete ::v-deep .el-input__inner {
    height: 28px;
    line-height: 28px;
    border: none;
    /* box-shadow: 1px 1px 8px 1px rgba(222, 225, 240, 0.6); */
}

.first_input.el-autocomplete ::v-deep .el-input__inner {
    height: 40px;
    line-height: 40px;
    border: none;
    /* box-shadow: 1px 1px 8px 1px rgba(222, 225, 240, 0.6); */
}

.el-radio {
    padding-right: 0px;
    /* background-color: white; */
    margin: 0;
    padding: 6px 25px 6px 20px;
    box-sizing: border-box;
    border-radius: 4px;
    color: black;
}

.el-radio ::v-deep .el-radio__input .el-radio__inner,
.el-radio ::v-deep .el-radio__input.is-checked .el-radio__inner {
    display: none;
}

.el-radio ::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: white;
    font-weight: bold;
}

.el-radio::v-deep .el-radio__label {
    padding-left: 0px;
    color: #9c9c9c;
}

.el-radio {
    flex: 1 0 33%;
    width: 33%;
    text-align: center;
    background-color: #dddddd;
    padding: 10px 0;
    border-radius: 13px;
}

.el-radio.is-checked {
    /* background-color: #11508a; */
    background-image: linear-gradient(to bottom, #1564ae, #0e4272);
}

.el-radio:last-of-type {
    /* background: url(@/assets/icon/tax.svg) no-repeat left 8px center;
    background-size: 20px; */
    background-color: white;
    flex: 1 0 22%;
    width: 22%;
    font-size: 12px;
    border: 1px solid #9c9c9c;
    padding: 6px 0 6px 0px;
    /* position: absolute; */
}

.el-radio:last-of-type img {
    width: 20px;
}

.el-radio:last-of-type .nav_button {
    display: flex;
    align-items: center;
    justify-content: center;
}

.el-radio:last-of-type ::v-deep .el-radio__input {
    display: none;
}

/* .el-radio.is-checked:last-of-type {
    background:  none;
    background-image: linear-gradient(to bottom, #1564ae, #0e4272);
    background-size: 20px;
    border-color: #11508a;
}  */

.el-radio ::v-deep .el-radio__label {
    font-size: 19px;
}

.el-radio:last-of-type ::v-deep .el-radio__label {
    font-size: 12px;

}

.el-radio:last-of-type ::v-deep .el-radio__label p {
    transform: scale(0.8);
}

.el-radio-group {
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    gap: 10px;
}

.table {
    background-color: white;
    padding: 0 15px;
}

.table table {
    width: 100%;
    font-size: 14px;
}

.table .tit {
    color: #005bab;
    margin-bottom: 10px;
}

.el-table ::v-deep th.el-table__cell {
    background-color: #035293;
    color: white;
    padding: 3px 0;
    font-size: 0.75em;
    text-align: center;
}

.el-table ::v-deep th.el-table__cell:last-of-type {
    border-radius: 0 5px 5px 0;
}

.el-table ::v-deep th.el-table__cell:first-of-type {
    border-radius: 5px 0 0 5px;
}

.el-table ::v-deep td.el-table__cell {
    padding: 3px 0;
    font-size: 12px;
    /* border: 2px solid white; */
    text-align: center;
    color: black;
    border-bottom: none;
}

.el-table--striped ::v-deep tr.el-table__row--striped td.el-table__cell {
    background: #f4f7ff !important;
    font-size: 12px;
    border-color: white;
}

.el-input--suffix ::v-deep .el-input__inner {
    font-size: 12px;
}

.total {
    display: flex;
    /* padding: 10px; */
    font-size: 16px;
    font-weight: bold;
    justify-content: center;
    color: #005bab;
}

.total>div {
    padding: 5px 15px;
    /* margin: 0 10px; */
}

.total span {
    margin-right: 10px;
}

.total .amount span:last-of-type {
    color: #fd7610;
}

.total .date span:last-of-type {
    color: #fd7610;
}

el-table {
    border: 1px solid white;
}

.end {
    margin: 10px 0;
    font-size: 12px;
}

.a_map {
    background-color: #f4f7ff;
    padding: 8px 10px;
    font-size: 12px;
    margin: 0 15px;
}

.a_map .desc {
    display: flex;
    font-size: 12px;
    margin-top: 5px;
}

.a_map .desc div {
    margin-right: 20px;
}

.a_map .desc div span:last-of-type {
    color: #fd7610;
}

.address {
    background-color: white;
}

.address img {
    width: 100%;
    height: 191.5px;
    object-fit: cover;
    border-radius: 10px 10px 0 0;
    opacity: 0.6;
}

.address_txt {
    transform: scale(0.9);
    padding: 5px;
    color: #005bab;
}

.address_txt span {
    color: black;
    font-weight: bold;
    display: inline-block;
    width: 40px;
    text-align: right;
}

.address,
.a_map,
.table {
    border-radius: 10px;
    /* box-shadow: 1px 1px 8px 1px rgba(222, 225, 240, 0.6); */
}

.explain {
    border-top: 1px dashed #dbe0e5;
    padding: 15px 0 0 0;
    margin: 10px 0 0 0;
}

.explain h3 {
    font-size: 17px;
    color: #005bab;
}

.explain .text {
    display: flex;
    gap: 20px;
}

.explain .text .er img {
    width: 70px;
    background-color: white;
    padding: 5px;
}

.explain .text .er {
    flex: 1 0 18%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    background-color: #f3f5ff;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid rgba(220, 230, 248, 0.8);
}

.explain .text .er .imgs {
    display: flex;
    justify-content: space-around;
    gap: 10px;
}

.er_button {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

}

.el-table ::v-deep .cell {
    line-height: 20px;
}

.explain .text .er button {
    color: white;
    font-weight: bold;
    border: none;
    background-color: #fd7610;
    font-size: 14px;
    text-align: center;
    padding: 5px 15px 5px 23px;
    border-radius: 5px;
    cursor: pointer;
    position: relative;
    width: 100%;
    /* left: -15px; */
}

.explain .text ul {
    flex: 1 0 35%;
    font-size: 12px;
    margin: 10px 0;
    color: #797c7f;
}

.explain .text ul:nth-of-type(2) {
    flex: 1 0 30%;
}

.explain .text ul li {
    margin: 5px 0;
    background: url(@/assets/img1/jian.svg) no-repeat left top 3px;
    background-size: 12px;
    padding-left: 18px;
}

.label {
    position: relative;
}

.num_pop {
    position: absolute;
    width: 200px;
    text-align: center;
    top: 0px;
    left: 0px;
    font-size: 12px;
    /* transform: scale(0.75); */
    color: #817f7e;
    animation: blinking 2s infinite;
}

.num_pop span {
    /* margin: 0 5px; */
    font-weight: bold;
    /* color: #fe0000; */
    color: #817f7e;
}

@keyframes blinking {
    0% {
        opacity: 1.0;
    }

    50% {
        opacity: 0.2;
    }

    100% {
        opacity: 1.0;
    }
}

.menu {
    background-color: #173d76;
    color: white;
    height: 100vh;
    padding: 20px;
}

.explain .text .er .message {
    display: flex;
    position: relative;
    /* flex-direction: column;
    justify-content: space-between;
    gap: 10px; */
    /* left: -40px; */
    /* margin-top: 10px; */
}

.explain .text .er .message button {
    padding: 0 0px;
    cursor: pointer;
    border-radius: 0 5px 5px 0;
    border: 1px solid #035294;
    border-left: none;
    background: #035294;
    color: white;
    height: 32px;
    position: absolute;
    right: 0;
    top: 0;
    width: 60px;
    /* display: none; */
}

.explain .text .er .message input[type='text'] {
    margin: 0;
    padding: 0 40px 0 10px;
    border: 1px solid #aaaaaa;
    border-radius: 5px;
    width: 100%;
    height: 30px;
    font-size: 12px;
}


.contact .text {
    display: flex;
    font-size: 12px;
    justify-content: center;
    gap: 5px;
    color: #0055a6;
    margin: 5px 0;
}

.contact .text .block:first-of-type {
    /* border-right: 1px solid #0055a6; */
}

.contact .text .block {
    padding: 0 10px;
    display: flex;
    gap: 20px;
}

.contact .text a {
    color: #0055a6;
}

.contact .message {
    background: url(@/assets/img/phone/7.svg) left center no-repeat;
    background-size: 35px;
    padding-left: 40px;
    margin-top: 10px;
    display: flex;
}

.contact .message {
    display: flex;
    margin: 10px 15px;
}

.contact .message button {
    cursor: pointer;
    padding: 7px 20px;
    width: 80px;
    border-radius: 0 5px 5px 0;
    border: 1px solid #035294;
    border-left: none;
    background: #035294;
    color: white;
}

.contact .message input[type='text'] {
    margin: 0;
    padding: 10px;
    border: 1px solid #aaaaaa;
    border-radius: 5px 0 0 5px;
    border-right: none;
    width: 100%;
}

.tax {
    padding: 10px 15px;
}

.footer {
    margin-top: 100px;
    font-size: 12px;
    color: #6f6f6f;
}

.footer a {
    color: #6f6f6f;
    text-decoration: none;
}

.footer a:hover {
    color: #ce8900;
    text-decoration: underline;
}

.footer {
    margin-top: 50px;
    text-align: center;
}

.footer span {
    display: block;
    line-height: 20px;
}
</style>
<style>
.lang.phone .el-select {
    width: 80px;
    background-color: #f28123;
    font-size: 12px;
    color: white;
    opacity: 0.5;
}

.lang.phone .el-button {
    padding: 5px;
    width: 80px;
}


.lang.phone .el-select input {
    line-height: 30px;
    height: 30px;
    background-color: unset;
    color: white;
    font-size: 12px;
}

.lan.phone .el-select .el-input__icon {
    width: 20px;
}

.lang.phone .el-select .el-input__icon {
    line-height: 30px;
}
</style>
 